module.exports = __webpack_public_path__ + "media/images/connection_background-4cdc292f6281c1cd7fa067531f241a9f.jpg";